import { Suspense } from 'react'

import { RouteObject } from 'react-router-dom'

import { ClientsMainLazy } from 'routes/Dashboard/routes/Clients/routes/ClientsMain'

import { ContentLoader } from 'shared/ui/ContentLoader'

import { clientsDetailRoutes } from './routes/ClientDetail'
import ClientsDetailWrapper from './ui/ClientDetailWrapper'
import ClientsWrapper from './ui/ClientsWrapper'

export const clientsRoutes: RouteObject[] = [
  {
    path: 'clients',
    element: <ClientsWrapper />,
    children: [
      {
        path: '',
        element: (
          <Suspense fallback={<ContentLoader />}>
            <ClientsMainLazy />
          </Suspense>
        ),
      },
      {
        path: ':clientId',
        element: (
          <Suspense fallback={<ContentLoader />}>
            <ClientsDetailWrapper />
          </Suspense>
        ),
        children: clientsDetailRoutes,
      },
    ],
  },
]
